import React from 'react';
import { Toast } from 'react-bootstrap';
// eslint-disable-next-line import/no-extraneous-dependencies
import classNames from 'classnames';

import styles from './OrderMsg.module.scss';

type Props = {
  isShow: boolean;
  error: string;
};

const OrderMsg: React.FC<Props> = ({ isShow, error }) => {
  if (!isShow) return null;

  return (
    <div className={classNames('p-3', styles.wrapper)}>
      <Toast show={isShow} delay={16000} className={styles.errorBody}>
        <Toast.Body>{error}</Toast.Body>
      </Toast>
    </div>
  );
};

export default OrderMsg;
